// import { firebase, googleAuthProvider } from '../firebase/firebase';
import axios from 'axios';
import isEmpty  from 'lodash/isEmpty';
import { history }  from '../routers/AppRouter'
import { picAppError, clearPicAppError }  from './picapp';
import getAppConfigParm  from '../config/AppConfig';
import dpbutils from '../utils/dpbutils';
// import { dispatch } from 'react-redux';


export const updateItemList = (items) => {
    let itemsCopy = copyListAndRemoveJsx(items);
    return {
        type: 'UPDATE_ITEM_LIST',
        list: itemsCopy
    }   
};

export const startUpdateItemList = (items) => {
    return (dispatch, getState ) => {

        /* obtain current event_id */
        let event_id = getState().event.active._id;
  
        // initialize pertinent error message related information
        let errmsg = '';
        let functionName = 'startUpdateItemList';
        let uri = 'PUT /event/contributions';
        let userEmail = getState().auth.user.email;

        /* Obtain user token */
        let token = getState().auth.token;
        // Construct url and request header 
        let url         = getAppConfigParm("picUrl") + `/event/contributions`; 
        let header      = getAppConfigParm("axiosConfig", token);
        let reqBody     = {
            event_id,   
            items
        }

        // Make api call to  update items list
        axios.put(url, reqBody, header)
         .then((response) => {
            /* update the store */
            dispatch(updateItemList(items));
          
            if (getState().picapp.error) {
                dispatch(clearPicAppError());
            }
        }).catch ((error) => {
            // Note: Although I was getting a response in then block and successfully saving the event info, 
            // I was getting a 204 http code along with an empty error object. Hence why the check below
            // If error object is empty, I do not dispatch an app error event. 
            if (!isEmpty(error)) {
                if (error.response) {   /* server responded with status code out of 2xx range(success) */
                    if (error.response.data.errmsg) {
                        errmsg = `UncaughtException ${error.response.status}: error encountered in ${functionName} for user ${userEmail}` +
                                           `${error.response.data.errmsg}`
                        dispatch(picAppError("Something wrong: May want to try logging out and logging in again"));
                    }
                } else if (error.request) { /* request made but no response received */
                    errmsg = `UncaughtException(1): no response from uri:${uri}' from function ${functionName} by user ${userEmail}`;
                    dispatch(picAppError("Server busy: please try us again later"));
                } else { /* something happened setting up request that triggered error */
                    if (error.message.indexOf('Network Error') !== -1 ) {
                        errmsg =  `NetworkError: occurred making axios call uri:'${uri}' from function ${functionName} by email:'${userEmail}' ErrorMsg: ${error.message}`;
                        dispatch(picAppError("Server busy:  please try us again later"));
                    } else {
                        errmsg = `UncaughtException(2): calling uri:'${uri}' from function ${functionName} from ${userEmail}`
                        dispatch(picAppError("Server busy: please try us again later"));
                    }
                }
            } else {
                errmsg = `UncaughtException(3): occurred with axios call uri:'${uri}' from function:${functionName}. Email:'${userEmail}'. If error object  empty, this may be a coding error (not API) within axios then block`;
            } /* end of !isEmpty */
            errmsg && dpbutils.saveErrorRecord(appname, filename, functionName, userEmail, errmsg, error);
        });
    }
};


/* This function makes a deep copy of the array of objects, while also clearing out the 
   actionIconsJsx property, which causes issues if saved into redux. */
function copyListAndRemoveJsx (list) {
    let newList = [];
    list.forEach((item) => {
        newList.push({
            contribution: item.contribution,
            quantity: item.quantity,
            actionIconsJsx: ""
        });
    });
      /* return modified copy of list */
    return newList;
}

// // Action creator for Save Event Info
// export const showSuccessMessage = (showSuccessMessage = true) => {
//     trace && prtStart(filename, 'showSuccessMessage(action creator)')
//     return  {
//       type: 'SHOW_SUCCESS_MESSAGE',
//       showSuccessMessage
//     }
// };

// // Action creator for Save Event Info
// export const saveEventInfo = (eventInfoObject = {}) => {
//   trace && prtStart(filename, 'saveEventInfo (action creator)')
//   return  {
//     type: 'SAVE_EVENT_INFO',
//     active: eventInfoObject
//   }
// };

// // Action creator for when clearing application error
// // export const clearActiveEvent = () => ({
// //     type: 'CLEAR_ACTIVE_EVENT' 
// // });
// export const clearActiveEvent = () => {
//     console.log("INSIDE ACTION - CLEAR ACTIVE EVENT")

//     return {
//     type: 'CLEAR_ACTIVE_EVENT' 
//     }
// };




// WEBPACK FOOTER //
// ./src/actions/items.js